import React from 'react';

const inputStyle = {
  width: '100%',
  border: '1px solid #e5e1db',
  borderRadius: 9,
  padding: '10px 14px',
  fontSize: 14,
  outline: 'none',
  background: '#faf9f7',
  color: '#1a1a1a',
  appearance: 'none',
};

const labelStyle = {
  fontSize: 11,
  letterSpacing: 1,
  textTransform: 'uppercase',
  color: '#999',
  display: 'block',
  marginBottom: 6,
};

function FilterBar({
  areaFilter, setAreaFilter,
  sizeFilter, setSizeFilter,
  typeFilter, setTypeFilter,
  search, setSearch,
  onApply, onClear,
  hasFilters,
}) {
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 18,
        border: '1px solid #ede9e3',
        padding: '1.75rem 2rem',
        marginBottom: '2rem',
        boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
      }}
    >
      <h3
        style={{
          fontSize: 11,
          letterSpacing: 2,
          textTransform: 'uppercase',
          color: '#aaa',
          marginBottom: '1.5rem',
        }}
      >
        Filter Designs
      </h3>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: 16,
          alignItems: 'end',
        }}
      >
        {/* Max Area */}
        <div>
          <label style={labelStyle}>Max Area (m²)</label>
          <input
            type="number"
            value={areaFilter}
            onChange={(e) => setAreaFilter(e.target.value)}
            placeholder="e.g., 50"
            style={inputStyle}
          />
        </div>

        {/* Stall Size */}
        <div>
          <label style={labelStyle}>Stall Size</label>
          <select
            value={sizeFilter}
            onChange={(e) => setSizeFilter(e.target.value)}
            style={{ ...inputStyle, color: sizeFilter ? '#1a1a1a' : '#aaa' }}
          >
            <option value="">All Sizes</option>
            <option value="small">Small</option>
            <option value="medium">Medium</option>
            <option value="large">Large</option>
          </select>
        </div>

        {/* Stall Type */}
        <div>
          <label style={labelStyle}>Stall Type</label>
          <select
            value={typeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
            style={{ ...inputStyle, color: typeFilter ? '#1a1a1a' : '#aaa' }}
          >
            <option value="">All Types</option>
            <option value="Island Stall">Island Stall</option>
            <option value="Three Side Open">Three Side Open</option>
            <option value="Two Side Open">Two Side Open</option>
            <option value="One Side Open">One Side Open</option>
            <option value="Mezzanine Stall">Mezzanine Stall</option>
          </select>
        </div>

        {/* Search */}
        <div>
          <label style={labelStyle}>Search</label>
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search stalls…"
            style={inputStyle}
            onKeyDown={(e) => e.key === 'Enter' && onApply()}
          />
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: 10 }}>
          <button
            onClick={onApply}
            style={{
              flex: 1,
              background: '#1a1a1a',
              border: 'none',
              borderRadius: 9,
              padding: '10px',
              color: '#fff',
              fontSize: 13,
              fontWeight: 500,
            }}
          >
            Apply
          </button>
          {hasFilters && (
            <button
              onClick={onClear}
              style={{
                flex: 1,
                background: '#f0ede8',
                border: '1px solid #e5e1db',
                borderRadius: 9,
                padding: '10px',
                color: '#666',
                fontSize: 13,
              }}
            >
              Clear
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default FilterBar;
